/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offline_Discard_Twins_BodyInputs */

const en_us2_offline_discard_twins_body = /** @type {(inputs: Offline_Discard_Twins_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`It will not be sent and cannot be recovered. The other identical workout add waiting behind it is discarded too.`);
	return /** @type {LocalizedString} */ (`It will not be sent and cannot be recovered. The other ${i?.count} identical workout adds waiting behind it are discarded too.`)
	
};

const pt_br2_offline_discard_twins_body = /** @type {(inputs: Offline_Discard_Twins_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Ela não será enviada e não dá para recuperar. A outra adição de treino igual, que espera atrás dela, também é descartada.`);
	return /** @type {LocalizedString} */ (`Ela não será enviada e não dá para recuperar. As outras ${i?.count} adições de treino iguais, que esperam atrás dela, também são descartadas.`)
	
};

const es_419_offline_discard_twins_body = /** @type {(inputs: Offline_Discard_Twins_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`No se enviará y no se puede recuperar. La otra adición de entrenamiento idéntica que espera detrás también se descarta.`);
	return /** @type {LocalizedString} */ (`No se enviará y no se puede recuperar. Las otras ${i?.count} adiciones de entrenamiento idénticas que esperan detrás también se descartan.`)
	
};

const pt_pt2_offline_discard_twins_body = /** @type {(inputs: Offline_Discard_Twins_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Não será enviada e não há forma de a recuperar. A outra adição de treino igual, que espera atrás dela, também é descartada.`);
	return /** @type {LocalizedString} */ (`Não será enviada e não há forma de a recuperar. As outras ${i?.count} adições de treino iguais, que esperam atrás dela, também são descartadas.`)
	
};

const fr_fr2_offline_discard_twins_body = /** @type {(inputs: Offline_Discard_Twins_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Elle ne sera pas envoyée et ne pourra pas être récupérée. L'autre ajout de séance identique en attente derrière elle est aussi supprimé.`);
	return /** @type {LocalizedString} */ (`Elle ne sera pas envoyée et ne pourra pas être récupérée. Les ${i?.count} autres ajouts de séance identiques en attente derrière elle sont aussi supprimés.`)
	
};

const de_de2_offline_discard_twins_body = /** @type {(inputs: Offline_Discard_Twins_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Er wird nicht gesendet und lässt sich nicht wiederherstellen. Das gleiche hinzugefügte Training, das dahinter wartet, wird ebenfalls verworfen.`);
	return /** @type {LocalizedString} */ (`Er wird nicht gesendet und lässt sich nicht wiederherstellen. Die ${i?.count} gleichen hinzugefügten Trainings, die dahinter warten, werden ebenfalls verworfen.`)
	
};

const it_it2_offline_discard_twins_body = /** @type {(inputs: Offline_Discard_Twins_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Non verrà inviata e non si potrà recuperare. Anche l'altra aggiunta di allenamento identica, in attesa dopo questa, viene scartata.`);
	return /** @type {LocalizedString} */ (`Non verrà inviata e non si potrà recuperare. Anche le altre ${i?.count} aggiunte di allenamento identiche, in attesa dopo questa, vengono scartate.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "It will not be sent and cannot be recovered. The other identical workout add waiting behind it is discarded too." |
* | * | "It will not be sent and cannot be recovered. The other {count} identical workout adds waiting behind it are discarded too." |
*
* @param {Offline_Discard_Twins_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_discard_twins_body = /** @type {((inputs: Offline_Discard_Twins_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Discard_Twins_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_discard_twins_body(inputs)
	if (locale === "es-419") return es_419_offline_discard_twins_body(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_discard_twins_body(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_discard_twins_body(inputs)
	if (locale === "de-DE") return de_de2_offline_discard_twins_body(inputs)
	if (locale === "it-IT") return it_it2_offline_discard_twins_body(inputs)
	return en_us2_offline_discard_twins_body(inputs)
});
export { offline_discard_twins_body as "offline.discard_twins_body" }